<template>
	<div
		:class="vFileUploadClass" class="v-file-upload" @click="triggerFileSelection()" @dragover.prevent
		@drop.prevent="handleFileDropped">
		<input
			:id="id"
			ref="input" :multiple="allowMultiple" class="sr-only" type="file"
			@input="handleFileChanged">
		<slot v-if="!uploading && outcome === null" name="idle">
			<div class="v-file-upload__idle">
				<VFileUploadCriteria/>
				<div v-if="hasInvalidFiles" class="v-file-upload__idle__invalid-files">
					<p class="v-file-upload__idle__invalid-files__text" v-html="cInvalidFilesText"/>
				</div>
				<label :for="id" class="v-file-upload__idle__label" @click.prevent>
					<span class="v-file-upload__idle__label__text" v-html="idleText"/>
				</label>
				<button
					class="v-file-upload__idle__browse-button" v-html="buttonText"
					@click.stop.prevent="triggerFileSelection()"/>
			</div>
		</slot>
		<slot v-else-if="uploading" name="uploading">
			<div class="v-file-upload__uploading">
				<template v-if="outcome === null">
					<p v-html="uploadingText"/>
				</template>
				<div v-else-if="outcome === false" class="v-file-upload__error">
					<OutcomeBadge :message="failedText" :result="outcome" class="outcome--open"/>
				</div>
				<div v-else-if="outcome === true" class="v-file-upload__success">
					<OutcomeBadge :message="cSuccessText" :result="outcome" class="outcome--open"/>
				</div>
				<dl class="v-file__progress">
					<div>
						<dt>Uploading</dt>
						<dd v-html="stringer('?').nGetText('# file', '# files', numberOfFiles).value"/>
					</div>
					<div>
						<dt>Total size</dt>
						<dd v-html="fileSize(progress.total)?.display || '—'"/>
					</div>
					<div class="v-file__progress__progress">
						<dt>Progress</dt>
						<dd>
							<dl>
								<dt>Size</dt>
								<dd v-html="fileSize(progress.uploaded)?.display || '—'"/>
								<dt>Percent</dt>
								<dd v-html="progress.percentDisplay || '—'"/>
							</dl>
						</dd>
					</div>
					<div>
						<dt>Time remaining</dt>
						<dd v-html="timeRemaining || '—'"/>
					</div>
					<div class="v-file__progress__indicator">
						<span class="v-file__progress__indicator__bar">
							<span
								:style="candleStyle" class="v-file__progress__indicator__bar__candle">
								<span></span>
							</span>
						</span>
					</div>
				</dl>
				<!--				<ul class="v-file-upload__uploading__files">-->
				<!--					<li-->
				<!--						v-for="(file, fileIndex) in files" :key="fileIndex"-->
				<!--						class="v-file-upload__uploading__files__file">-->
				<!--						<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">-->
				<!--							<g stroke-linecap="round" stroke-linejoin="round">-->
				<!--								<polyline points="28.8 1.7 28.8 13.7 40.8 13.7"/>-->
				<!--								<polyline points="40.8 22.7 40.8 13.7 28.8 1.7 6.8 1.7 6.8 22.7"/>-->
				<!--								<polyline points="6.8 40.7 6.8 45.7 40.8 45.7 40.8 40.7"/>-->
				<!--								<rect height="18" width="44" x="1.8" y="22.7"/>-->
				<!--								<text-->
				<!--									dominant-baseline="middle" text-anchor="middle" x="50%" y="32.5"-->
				<!--									v-html="stringer(file.type).split('/').value(1)"/>-->
				<!--								&lt;!&ndash;								<text transform="translate(11.6 35.2)">&ndash;&gt;-->
				<!--								&lt;!&ndash;									<tspan x="0" y="0" v-html="stringer(file.type).split('/').value(1)"/>&ndash;&gt;-->
				<!--								&lt;!&ndash;								</text>&ndash;&gt;-->
				<!--							</g>-->
				<!--						</svg>-->
				<!--						<dl>-->
				<!--							<dt class="sr-only">Name</dt>-->
				<!--							<dd v-html="file.name"/>-->
				<!--							<dt class="sr-only">Size</dt>-->
				<!--							<dd v-html="fileSize(file.size / 1000).display"/>-->
				<!--						</dl>-->
				<!--					</li>-->
				<!--				</ul>-->
			</div>
		</slot>
	</div>
</template>
<script>
import VFileUploadCriteria from "@/common/components/v-upload/v-file-upload-criteria.vue";
import Stringer from "@/packages/stringer/src/Stringer";
import {isNull} from "lodash";
import OutcomeBadge from "../OutcomeBadge";

export default {
	components: {
		VFileUploadCriteria,
		OutcomeBadge,
	},

	data() {
		return {
			action: null,
			files: [],
			data: null,
			uploading: false,
			outcome: null,
			resetTimeout: null,
			progress: {
				uploaded: null,
				total: null,
				percent: null,
				percentDisplay: null,
				estimatedTimeRemaining: null,
			},
		};
	},

	computed: {
		vFileUploadClass() {
			return {
				"v-file-upload--multiple": this.allowMultiple,
				"v-file-upload--idle": !this.uploading,
				"v-file-upload--uploading": this.uploading,
				"v-file-upload--invalid-files": this.hasInvalidFiles,
				"v-file-upload--failed": this.outcome === false,
				"v-file-upload--succeeded": this.outcome === true,
			};
		},
		acceptedMimes() {
			return this.stringer(this.accept).split("|").all();
		},
		acceptedFileTypes() {
			return this.stringerCollection(this.acceptedMimes).map((value) => {
				return value.split("/").get(1).upper();
			}).all();
		},
		allowMultiple() {
			return this.maxFiles !== 1;
		},
		filesFailingTypeCriteria() {
			return _.filter(this.files, file => {
				if (!file.type) {
					return this.acceptedMimes.indexOf("text/plain") === -1;
				}
				return this.acceptedMimes.indexOf(file.type) === -1;
			});
		},
		filesFailingMaxSizeCriteria() {
			if (!this.maxKB) {
				return [];
			}
			return _.filter(this.files, file => {
				return (file.size / 1000) > this.maxKB;
			});
		},
		filesFailingMaxFilesCriteria() {
			if (this.maxFiles === null) {
				return [];
			}
			return [...this.files].slice(this.maxFiles);
		},
		filesFailingUploadCriteria() {
			return [...this.filesFailingTypeCriteria, ...this.filesFailingMaxSizeCriteria];
		},
		numberOfFiles() {
			return this.files.length;
		},
		numberOfInvalidFiles() {
			return this.filesFailingUploadCriteria.length;
		},
		hasInvalidFiles() {
			return this.filesFailingUploadCriteria.length > 0;
		},
		cInvalidFilesText() {
			if (this.filesFailingMaxFilesCriteria.length) {
				return `Too many files ${this.action}`;
			}

			if (this.invalidFilesText) {
				return this.invalidFilesText;
			}

			if (this.numberOfFiles === 1) {
				return `The ${this.action} file failed to meet the upload criteria`;
			}

			return new Stringer("?").nGetText(
				`One of the ${this.numberOfFiles} files ${this.action} failed to meet the upload criteria`,
				`${this.numberOfInvalidFiles} of the ${this.numberOfFiles} files ${this.action} failed to meet the upload criteria`,
				this.filesFailingUploadCriteria.length,
			).value;
		},
		cSuccessText() {
			if (this.successText) {
				return this.successText;
			}
			return new Stringer("? uploaded").nGetText("File", "# files", this.numberOfFiles).value;
		},
		maxFileSize() {
			if (!this.maxKB) {
				return null;
			}
			return this.fileSize(this.maxKB);
		},
		candleStyle() {
			return {
				width: !this.progress.percent ? 0 : this.progress.percent + "%",
			};
		},
		timeRemaining() {
			if (!this.progress.estimatedTimeRemaining) {
				return null;
			}
			if (this.progress.estimatedTimeRemaining <= 15) {
				return this.progress.estimatedTimeRemaining;
			}

			return dayjs.duration(this.progress.estimatedTimeRemaining, "seconds").humanize();
		},
	},

	props: {
		id: {
			required: false,
			type: String,
			default() {
				return "v-file-upload--" + this._uid;
			},
		},
		post: {
			required: false,
			type: String,
		},
		accept: {
			required: true,
			type: String,
		},
		maxKB: {
			required: false,
			type: Number,
			default() {
				return null;
			},
		},
		maxFiles: {
			required: false,
			type: Number,
			default() {
				return 1;
			},
		},
		meta: {
			required: false,
			type: Object,
			default() {
				return {};
			},
		},
		idleText: {
			required: false,
			type: String,
			default() {
				return new Stringer("Drag and drop your ? here or click to browse").nGetText("file", "files", this.maxFiles).value;
			},
		},
		buttonText: {
			required: false,
			type: String,
			default() {
				return "Browse files";
			},
		},
		invalidFilesText: {
			required: false,
			type: String,
			default() {
				return null;
			},
		},
		invalidFilesButtonText: {
			required: false,
			type: String,
			default() {
				return "Try again";
			},
		},
		uploadingText: {
			required: false,
			type: String,
			default() {
				return "Uploading";
			},
		},
		failedText: {
			required: false,
			type: String,
			default() {
				return "Upload failed";
			},
		},
		successText: {
			required: false,
			type: String,
			default() {
				return null;
			},
		},
		uploadDelay: {
			required: false,
			type: Number,
			default() {
				return 500;
			},
		},
		resetDelay: {
			required: false,
			type: Number,
			default() {
				return 3000;
			},
		},
	},

	methods: {
		isNull,
		triggerFileSelection() {
			if (this.uploading) {
				return;
			}
			this.refs.input?.click();
		},
		handleFileChanged(event) {
			this.action = "selected";
			this.processFiles(event.target.files);
		},
		handleFileDropped(event) {
			this.action = "dropped";
			this.processFiles(event.dataTransfer.files);
		},
		processFiles(files) {
			if (this.uploading) {
				return;
			}

			this.files = files;

			if (this.filesFailingUploadCriteria.length) {
				return;
			}

			if (!this.post) {
				return this.$emit("input", this.files);
			}

			this.sendFiles();
		},
		sendFiles() {
			if (!this.files.length) {
				return;
			}

			this.$emit("uploading", this.files);

			this.data = new FormData();
			this.uploading = true;
			this.outcome = null;

			this.data.append(this.allowMultiple ? "files" : "file", this.allowMultiple ? this.files : this.files[0]);
			this.data.append("meta", JSON.stringify(this.meta));

			this.progress = Object.assign(this.progress, {
				total: _.sumBy(this.files, file => {
					return file.size / 1000;
				}).toFixed(2),
				uploaded: null,
				percent: null,
				percentDisplay: null,
				estimatedTimeRemaining: null,
			});

			setTimeout(() => {
				let outcome = null;

				http().post(this.post, this.data, {
					"Content-Type": "multipart/form-data",
					onUploadProgress: (progressEvent) => {
						let estimatedTimeRemaining = progressEvent.estimated;
						let percent = (progressEvent.loaded * 100) / progressEvent.total;
						this.progress = Object.assign(this.progress, {
							uploaded: Math.min(this.progress.total, progressEvent.loaded / 1000),
							percent: percent,
							percentDisplay: Math.round(percent) + "%",
							estimatedTimeRemaining: estimatedTimeRemaining > 0 ? estimatedTimeRemaining.toFixed(2) : null,
						});
					},
				}).then(response => {
					outcome = true;
					this.progress = Object.assign(this.progress, {
						uploaded: this.progress.total,
						percent: 100,
						percentDisplay: "100%",
					});
					this.reset(this.resetDelay, () => {
						this.$emit("succeeded", response);
					});
				}).catch(error => {
					outcome = false;
					this.progress = Object.assign(this.progress, {
						uploaded: 0,
						percent: null,
						percentDisplay: null,
					});
					this.$emit("failed", error);
				}).finally(() => {
					this.outcome = outcome;
					this.progress = Object.assign(this.progress, {
						percent: 100,
						estimatedTimeRemaining: null,
					});
				});
			}, this.uploadDelay);
		},
		reset(delay = null, callback = null) {
			this.resetTimeout = setTimeout(() => {
				clearTimeout(this.resetTimeout);
				this.refs.input.value = "";
				this.action = null;
				this.files = [];
				this.data = null;
				this.uploading = false;
				this.outcome = null;
				this.resetTimeout = null;
				if (callback) {
					callback.call();
				}
			}, delay || 0);
		},
		fileSize(size) {
			let units = {
				TB: 0.000000001,
				GB: 0.000001,
				MB: 0.001,
				KB: 1,
			};
			let conversions = _.map(units, (value, unit) => {
				value = (size * value).toFixed(2);
				return {
					unit: unit,
					value: value,
					display: value + unit,
				};
			});
			return _.find(conversions, data => {
				return data.value >= 1;
			});
		},
	},
};
</script>
